import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

interface Product {
  id: number;
  name: string;
  price: number;
  originalPrice?: number;
  image: string;
  category: string;
  skinType: string[];
  rating: number;
  reviews: number;
  badge?: string;
}

const ShopPage = () => {
  const [sortBy, setSortBy] = useState('featured');

  const products: Product[] = [
    {
      id: 1,
      name: 'سيروم فيتامين سي المضيء',
      price: 299,
      originalPrice: 399,
      image: 'https://public.readdy.ai/ai/img_res/3c9e6a98e031b105999043b1f2ed5a11.jpg',
      category: 'skincare',
      skinType: ['all', 'dry', 'normal'],
      rating: 4.8,
      reviews: 234,
      badge: 'الأكثر مبيعاً'
    },
    {
      id: 2,
      name: 'كريم الترطيب المكثف',
      price: 249,
      image: 'https://readdy.ai/api/search-image?query=luxury%20moisturizer%20cream%20jar%20on%20soft%20pink%20background%2C%20elegant%20minimal%20product%20photography%2C%20rose%20petals%20decoration%2C%20clean%20aesthetic%2C%20professional%20cosmetic%20photography%2C%20high-end%20skincare%20product&width=400&height=500&seq=prod2&orientation=portrait',
      category: 'skincare',
      skinType: ['dry', 'sensitive'],
      rating: 4.9,
      reviews: 189
    },
    {
      id: 3,
      name: 'باليت ظلال العيون الوردية',
      price: 349,
      image: 'https://readdy.ai/api/search-image?query=luxury%20pink%20eyeshadow%20palette%20on%20soft%20pink%20silk%20fabric%2C%20elegant%20minimal%20product%20photography%2C%20rose%20gold%20packaging%2C%20clean%20white%20background%2C%20professional%20makeup%20photography%2C%20high-end%20cosmetic%20product&width=400&height=500&seq=prod3&orientation=portrait',
      category: 'makeup',
      skinType: ['all'],
      rating: 4.7,
      reviews: 156,
      badge: 'جديد'
    },
    {
      id: 4,
      name: 'أحمر شفاه مات فاخر',
      price: 179,
      image: 'https://readdy.ai/api/search-image?query=luxury%20matte%20lipstick%20on%20soft%20pink%20background%2C%20elegant%20minimal%20product%20photography%2C%20rose%20gold%20packaging%2C%20clean%20aesthetic%2C%20professional%20cosmetic%20photography%2C%20high-end%20makeup%20product&width=400&height=500&seq=prod4&orientation=portrait',
      category: 'makeup',
      skinType: ['all'],
      rating: 4.6,
      reviews: 298
    },
    {
      id: 5,
      name: 'لوشن الجسم بالورد',
      price: 199,
      image: 'https://readdy.ai/api/search-image?query=luxury%20rose%20body%20lotion%20bottle%20on%20soft%20pink%20silk%20fabric%2C%20elegant%20minimal%20product%20photography%2C%20rose%20petals%20decoration%2C%20clean%20white%20background%2C%20professional%20cosmetic%20photography%2C%20high-end%20bodycare%20product&width=400&height=500&seq=prod5&orientation=portrait',
      category: 'bodycare',
      skinType: ['all', 'dry'],
      rating: 4.8,
      reviews: 167
    },
    {
      id: 6,
      name: 'ماسك الطين المنقي',
      price: 229,
      image: 'https://readdy.ai/api/search-image?query=luxury%20clay%20mask%20jar%20on%20soft%20pink%20background%2C%20elegant%20minimal%20product%20photography%2C%20clean%20aesthetic%2C%20professional%20cosmetic%20photography%2C%20high-end%20skincare%20product&width=400&height=500&seq=prod6&orientation=portrait',
      category: 'skincare',
      skinType: ['oily', 'combination'],
      rating: 4.7,
      reviews: 143
    },
    {
      id: 7,
      name: 'عطر Rose Mist الفاخر',
      price: 499,
      originalPrice: 599,
      image: 'https://readdy.ai/api/search-image?query=luxury%20perfume%20bottle%20on%20soft%20pink%20silk%20fabric%2C%20elegant%20minimal%20product%20photography%2C%20rose%20gold%20accents%2C%20clean%20white%20background%2C%20professional%20fragrance%20photography%2C%20high-end%20perfume%20product&width=400&height=500&seq=prod7&orientation=portrait',
      category: 'fragrance',
      skinType: ['all'],
      rating: 4.9,
      reviews: 312,
      badge: 'الأكثر مبيعاً'
    },
    {
      id: 8,
      name: 'مجموعة فرش المكياج',
      price: 399,
      image: 'https://readdy.ai/api/search-image?query=luxury%20makeup%20brush%20set%20on%20soft%20pink%20background%2C%20elegant%20minimal%20product%20photography%2C%20rose%20gold%20handles%2C%20clean%20aesthetic%2C%20professional%20cosmetic%20photography%2C%20high-end%20beauty%20tools&width=400&height=500&seq=prod8&orientation=portrait',
      category: 'tools',
      skinType: ['all'],
      rating: 4.8,
      reviews: 201
    },
    {
      id: 9,
      name: 'تونر الورد المنعش',
      price: 189,
      image: 'https://readdy.ai/api/search-image?query=luxury%20rose%20toner%20bottle%20on%20soft%20pink%20silk%20fabric%2C%20elegant%20minimal%20product%20photography%2C%20rose%20petals%20decoration%2C%20clean%20white%20background%2C%20professional%20cosmetic%20photography%2C%20high-end%20skincare%20product&width=400&height=500&seq=prod9&orientation=portrait',
      category: 'skincare',
      skinType: ['all', 'sensitive'],
      rating: 4.7,
      reviews: 178
    },
    {
      id: 10,
      name: 'كريم العين المضاد للتجاعيد',
      price: 279,
      image: 'https://readdy.ai/api/search-image?query=luxury%20eye%20cream%20jar%20on%20soft%20pink%20background%2C%20elegant%20minimal%20product%20photography%2C%20rose%20gold%20accents%2C%20clean%20aesthetic%2C%20professional%20cosmetic%20photography%2C%20high-end%20skincare%20product&width=400&height=500&seq=prod10&orientation=portrait',
      category: 'skincare',
      skinType: ['all', 'mature'],
      rating: 4.9,
      reviews: 156,
      badge: 'جديد'
    },
    {
      id: 11,
      name: 'بودرة الإضاءة الوردية',
      price: 259,
      image: 'https://readdy.ai/api/search-image?query=luxury%20pink%20highlighter%20powder%20on%20soft%20pink%20silk%20fabric%2C%20elegant%20minimal%20product%20photography%2C%20rose%20gold%20packaging%2C%20clean%20white%20background%2C%20professional%20makeup%20photography%2C%20high-end%20cosmetic%20product&width=400&height=500&seq=prod11&orientation=portrait',
      category: 'makeup',
      skinType: ['all'],
      rating: 4.6,
      reviews: 134
    },
    {
      id: 12,
      name: 'شامبو الورد للشعر',
      price: 219,
      image: 'https://readdy.ai/api/search-image?query=luxury%20rose%20shampoo%20bottle%20on%20soft%20pink%20background%2C%20elegant%20minimal%20product%20photography%2C%20clean%20aesthetic%2C%20professional%20cosmetic%20photography%2C%20high-end%20haircare%20product&width=400&height=500&seq=prod12&orientation=portrait',
      category: 'haircare',
      skinType: ['all'],
      rating: 4.8,
      reviews: 189
    }
  ];

  return (
    <div className="min-h-screen bg-white" dir="rtl">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-16 bg-gradient-to-br from-rose-50 via-pink-50 to-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-800 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              متجر <span className="text-rose-400">Rose Mist</span>
            </h1>
            <p className="text-lg text-gray-600">
              اكتشفي مجموعتنا الحصرية من منتجات التجميل والعناية الطبيعية
            </p>
          </div>
        </div>
      </section>

      {/* Shop Section */}
      <section className="py-16">
        <div className="container mx-auto px-4 lg:px-8">
          {/* Sort & Count */}
          <div className="flex items-center justify-between mb-8">
            <p className="text-gray-600">
              عرض <strong className="text-rose-400">{products.length}</strong> منتج
            </p>
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="px-4 py-2 border border-gray-200 rounded-xl text-sm focus:outline-none focus:border-rose-400"
            >
              <option value="featured">الأكثر شهرة</option>
              <option value="price-low">السعر: من الأقل للأعلى</option>
              <option value="price-high">السعر: من الأعلى للأقل</option>
              <option value="rating">الأعلى تقييماً</option>
              <option value="newest">الأحدث</option>
            </select>
          </div>

          {/* Products */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-product-shop>
            {products.map(product => (
              <Link
                key={product.id}
                to={`/product/${product.id}`}
                className="group bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300"
              >
                <div className="relative h-80 overflow-hidden bg-gradient-to-br from-rose-50 to-pink-50">
                  {product.badge && (
                    <div className="absolute top-4 right-4 bg-rose-400 text-white px-4 py-1.5 rounded-full text-xs font-bold z-10">
                      {product.badge}
                    </div>
                  )}
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-bold text-gray-800 mb-2 group-hover:text-rose-400 transition-colors">
                    {product.name}
                  </h3>
                  <div className="flex items-center gap-2 mb-3">
                    <div className="flex items-center gap-1">
                      <i className="ri-star-fill text-yellow-400 text-sm"></i>
                      <span className="text-sm font-bold text-gray-700">{product.rating}</span>
                    </div>
                    <span className="text-xs text-gray-500">({product.reviews} تقييم)</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="text-2xl font-bold text-rose-400">{product.price} ر.س</span>
                    {product.originalPrice && (
                      <span className="text-sm text-gray-400 line-through">{product.originalPrice} ر.س</span>
                    )}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ShopPage;
